import {EventEmitter, Injectable} from "@angular/core";
import {IPlatformToolHandler} from "@shared/components/platform-tool/platform-tool-container/platform-tool-component";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {MagicLinkModel, TabModel} from "@shared/models/platform-tool-models";
import {CommandBase, ContentScope, PlatformCommand, PlatformCommandResponse} from "@shared/commands/command-base";
import {DynamicFormService} from "@shared/services/dynamic-form.service";
import {SocketClusterService} from "@core/services/socket-cluster.service";
import {QueryProvider} from "@shared/queries/query-provider";
import {select, Store} from "@ngrx/store";
import {IDac6ReporterState} from "@features/dac6-reporter/store/reducers/dac6-reporter.reducer";
import {Observable, Subject} from "rxjs";
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {
  SetCurrentFormOverviewAction,
  SetCurrentRightSideComponentAction
} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {Dac6ReporterApiService} from "@features/dac6-reporter/services/dac6-reporter.service";
import {Guid} from "guid-typescript";
import {ParticleCacheService} from "@core/services/particle-cache.service";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";
import {IQueryState} from "@shared/store/reducers/query.reducer";
import {ParticleCacheModel} from "@shared/models/particle-cache.model";
import {take, takeUntil} from 'rxjs/operators';
import {DynamicFieldItem} from "@shared/components/dynamic-form/dynamic-form-item";
import {getViewType, ParticleState} from "@shared/store/reducers/particle.reduer";
import {Router} from "@angular/router";
import {DownloadType, FieldefinitionDataType} from "@features/dac6-reporter/Fields";
import {
  FillingManagerFormExportCommand, FormAttachmentToFilingTaskCommand,
  SaveFormFieldCommand,
  SetExportFormSelectedItemCommand, SpreadsheetFillingManagerFormExportCommand
} from "@features/dac6-reporter/commands/dac6-reporter.command";
import {CommandService} from "@core/services/command.service";
import {DialogModel} from "@shared/models/dialog.model";
import {DialogService} from "@shared/services/dialog-service";
import {FuseSplashScreenService} from "@barebone-fuse/@fuse/services/splash-screen.service";
import {MatDialog} from "@angular/material/dialog";
import {FilingErrorReportComponent} from "@features/dac6-reporter/components/filing-error-report/filing-error-report.component";
import {FileDialogComponent} from "@features/file-manager/component/file-dialog/file-dialog.component";
import {SnackBarService} from "@core/services/snack-bar.service";
import {TransmitFileCommand} from "@features/dac6-reporter/components/transmissions/commands/transmission.command";
import {ExcelExportSourceFileDownloadAction} from "@features/dac6-reporter/store/actions/dac6-reporter.actions";
import {GraphqlContentScope} from "@shared/models/graphql-content-scope.model";
import {TaskManagerService} from "@features/task-manager/services/task-manager.service";
import {NotificationMessageModel} from "@shared/models/notification-message.model";
import {QueryModel} from "@shared/models/query-model";
import {DeleteQueryAction} from "@shared/store/actions/query.actions";
import {Api} from "@shared/constants/common-field.constants";
import {Configuration} from "@shared/models/configuration";
import {FormFilingManagerService, TransmitData} from "@features/filing-manager/services/form-filing-manager.service";
import {RootDynamicComponentHelper} from "@shared/helpers/root-dynamic-component-helper";
import {FileManagementService} from "@core/services/file-management.service";

@Injectable({
  providedIn: 'root'
})
export class PlatformToolDac6FilingFormHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;

  formId: any;
  private hasSubscribedToSocketCluster: boolean;
  item$: Observable<any>;
  item: any;
  sourceType: string;
  targetApi: string;
  formFieldsErrorInformation: any;
  formFieldsValidationState: any;
  editedFields: string[] = [];
  endpointName: string;
  unSubscribe$ = new Subject<void>();
  formState$: any;
  formField: DynamicFieldItem;
  containerClass: string;
  fieldConfig: any;
  showLanguageOption: boolean;
  showOriginal: boolean;
  changedValuesFieldDefination = [];
  totalChanges: number = 0;
  private queryModels: QueryModel[] = [];
  selectedSectionHearderKey: string;
  viewType: string;
  private filingExportOptions: any;
  isDirty: boolean;
  saveButtonCaption: string;
  private executionId: string;
  transmitToAuthority: boolean;
  public rightElementsCount: any;
  private fileManagerFormExportActivityCommand: PlatformCommand;

  constructor(
    private dynamicFormService: DynamicFormService,
    private socketClusterService: SocketClusterService,
    private store: Store<IDac6ReporterState>,
    private dac6ApiService: Dac6ReporterApiService,
    private particleCacheService: ParticleCacheService,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private queryState: Store<IQueryState>,
    private particleStore: Store<ParticleState>,
    private router: Router,
    protected commandService: CommandService,
    private dialogService: DialogService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private dialog: MatDialog,
    private snackBarService: SnackBarService,
    private taskManagerService: TaskManagerService,
    private formFilingManagerService: FormFilingManagerService,
    private fileManagementService: FileManagementService,
  ) {
    this.containerClass = 'content';
    this.showLanguageOption = true;
    this.showOriginal = false;
    this.selectedSectionHearderKey = '';
    this.saveButtonCaption = 'Save';
  }

  executeCommand(command: PlatformCommand) {
    command.fieldValues['IsTranslated'] = !this.showOriginal;
    if (command.fieldValues['RedirectUrl']) {
      this.router.navigateByUrl(command.fieldValues['RedirectUrl']);
    } else {
      switch (command.name) {
        case 'SaveChanges':
          this.save(command);
          break;
        case 'ExportFilingFormCommand':
          console.log('We are in ExportFilingFormCommand');
          this.showExportFilingDialog(false,command);
          break;
        case 'ExportFilingManagerFormCommand':
          console.log('We are in ExportFilingFormCommand');
          this.executionId = Guid.create().toString();
          let formSourceType = this.item ? this.item.cells ? this.item.cells['FormSourceType'] ? this.item.cells['FormSourceType'].value : '' : '' : '';
          const countryCode = this.item.cells['CountryCode'].value;
          let t = new TransmitData(formSourceType, '',false, this.filingExportOptions, this.rightElementsCount, countryCode,this.formId,this.executionId,this.showOriginal,this.item.cells)
          this.formFilingManagerService.handleDownloadNextAction(t);
          break;
        case 'LanguageToggle':
          console.log('We are in LanguageToggle');
          this.updateLanguageToogle(command);
          break;
        case 'CreateSurveyTemplate':
          this.startDataSurvey();
          break;
        case 'ExportAndTransmit':
          this.exportAndTransmit(command);
          break;
        case 'ExportAndTransmitFilingManagerFormCommand':
          this.executionId = Guid.create().toString();
          let fSourceType = this.item ? this.item.cells ? this.item.cells['FormSourceType'] ? this.item.cells['FormSourceType'].value : '' : '' : '';
          const cCode = this.item.cells['CountryCode'].value;
          let tt = new TransmitData(fSourceType, '', true, this.filingExportOptions, this.rightElementsCount, cCode,this.formId,this.executionId,this.showOriginal,this.item.cells)
          this.formFilingManagerService.handleDownloadNextAction(tt);
          break;
        case 'CreateGmtRefreshFormDialogCommand':
          this.refreshForm(command);
        break;
        default:
          this.executePlatformCommand(command);
      }
    }
  }
  refreshForm(command : PlatformCommand) {
    console.log(`CreateGmtRefreshFormDialogCommand::::`, command);
    this.executePlatformCommand(command);
  }
  reloadPage() {
    this.router.navigate([this.router.url])
      .then(() => {
        window.location.reload();
      });
  }
  executePlatformCommand(command: PlatformCommand) {
    if(command.fieldValues['IsFormDataRefreshStarted']){
      this.fuseSplashScreenService.show();
      this.fuseSplashScreenService.showWaitScreenMessage(`Form data refreshing in progress...`);
    }
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        this.fuseSplashScreenService.hide();
        if (response.fieldValues['DownloadUrl'] && response.fieldValues['FileName']) {
          this.fileManagementService.downloadOneTimeSignedUrl(response.fieldValues['DownloadUrl'], response.fieldValues['FileName']);
          return;
        }
        if (response.fieldValues['DownloadFileResponseModel']) {
          const downloadResponseModel = response.fieldValues['DownloadFileResponseModel'];
          const fileId = downloadResponseModel?.fileId;
          this.fileManagementService.downloadClientFileWithId(fileId).subscribe(payload => {
            this.fuseSplashScreenService.hide();
            this.fileManagementService.openSaveFileWindow(payload, downloadResponseModel.fileName);
          });
        }
        if(response?.fieldValues['RedirectCommand']) {
          this.executePlatformCommand(response.fieldValues['RedirectCommand']);
        } else if (response.fieldValues['RedirectUrl']) {
          if (response.fieldValues['PlatformLinkModel']) {
            this.commandService.handleResponse(response);
            this.invalidateSubject.invalidate('HardReload' + Guid.create().toString());
            return;
          }
          this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
          return;
        }
        else if (response.fieldValues['RedirectToExternalUrl']) {
          console.log(`RedirectToExternalUrl : ${response.fieldValues['RedirectToExternalUrl']}`);
          window.open(response.fieldValues['RedirectToExternalUrl']);
          return;
        }
        if (response.fieldValues['Refresh']) {
          this.fuseSplashScreenService.hide();
          this.reloadPage();
          //QueryProvider.invokeQuery(this.store, 'FormRowById', {'[ID]': this.formId});
        }
    },
      error => {
        this.fuseSplashScreenService.hide();
        console.error(`${command.name} failed!!!`, error);
      }
    );
  }

  valueChanged($event) {
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.unSubscribe$ = new Subject<void>();
    this.dynamicFormService.initialize();
    this.formId = this.magicLinkModel.fieldValues['Id'];
    this.endpointName = this.magicLinkModel.fieldValues['EndpointApi'] || this.magicLinkModel.fieldValues['Api'];
    this.subscribeToSocketCluster(this.formId);
    let formRowQueryKey = this.getformRowQueryKey();
    let filingOptionsQueryKey = this.getFilingOptionsQueryKey();
    let query = QueryProvider.getQuery(formRowQueryKey);

    if(this.endpointName == Api.FilingManagerApi || this.endpointName === Api.Spreadsheet){
      query.api = this.endpointName;
    }
    else {
      query.api = Api.DAC6;
    }
    this.queryModels.push(query);
    this.store.pipe(takeUntil(this.unSubscribe$), select(getQueryResponse, formRowQueryKey)).subscribe(item => {
      if (item && item.cells) {
        console.log('form row id:', item);
        if (!this.item) {
          this.item = item;
        }
        if (this.item && this.item.id !== item.id) {
          this.item = item;
        }
        Object.keys(item.cells).forEach(key => {
          if (!this.item.cells[key]) {
            this.item.cells[key] = {};
          }
          this.item.cells[key].isDirty = false;
          this.item.cells[key].actualValue = item.cells[key].value;
          this.item.cells[key].value = item.cells[key].value;
          this.item.cells[key].displayText = item.cells[key].displayText;
        });
        this.editedFields.splice(0, this.editedFields.length);
        this.dynamicFormService.emitEditedFields(this.editedFields);
        this.isDirty = false;
        this.sourceType = this.item.cells['FormSourceType'].value;
        this.dynamicFormService.emitSourceType(this.sourceType);
        if (this.sourceType) {
          const countryCode = this.item.cells['CountryCode'].value;
          if (countryCode && this.endpointName !=='SpreadsheetApi') {
            const formViewItem = { 'code': countryCode, 'querykey': 'Dac6FormOverview'};
            this.platformSidebarStore.dispatch(new SetCurrentFormOverviewAction(formViewItem));
          }
        }
        if (!this.formState$) {
          this.getFormFieldConfiguration();
        } else {
          this.invalidateSubject.invalidate('PlatformToolDynamicFormHandler|' + Guid.create().toString());
        }
        QueryProvider.invokeQuery(this.store, filingOptionsQueryKey, {'[CODE]': this.item.cells['CountryCode'].value, '[SOURCE_TYPE]': this.item.cells['FormSourceType'].value, '[SCENARIO_TYPE]': this.item.cells['ScenarioType']?.value ? this.item.cells['ScenarioType'].value : ''});
        this.getAllHeaderSection(this.formId, this.endpointName);
        /*this.dac6ApiService.getAllHeaderSectionsFormFieldsErrorInformation(this.formId).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
          if (response) {
            this.formFieldsErrorInformation = {};
            response.forEach(item => this.formFieldsErrorInformation[item.headerSectionKey + '__' + item.formId] = item);
            this.setFieldValidation(response);
            this.dynamicFormService.emitFormFieldsErrorInformation(this.formFieldsErrorInformation);
            this.dynamicFormService.emitFormFieldsValidationState(this.formFieldsValidationState);
            this.isReadyToLoadContainer();
            this.invalidateSubject.invalidate('PlatformToolDynamicFormHandler|' + Guid.create().toString());
          }
        });*/
        this.dynamicFormService.emitItems(this.item);
        this.isReadyToLoadContainer();
      }
    });
    QueryProvider.invokeQuery(this.store, formRowQueryKey, {'[ID]': this.formId});
    this.particleStore.pipe(select(getViewType)).pipe(takeUntil(this.unSubscribe$)).subscribe(viewType => {
      this.viewType = viewType;
    });
    this.store.pipe(takeUntil(this.unSubscribe$), select(getQueryResponse, filingOptionsQueryKey)).subscribe(options => {
      if (options) {
        this.filingExportOptions = options;
        this.dynamicFormService.emitFilingExportOptions(this.filingExportOptions);
      }
    });
    this.platformSidebarStore.dispatch(
      new SetCurrentRightSideComponentAction(
        {component: 'FormOverViewComponent', data: {isUserAction: false}, componentInfo: {id: 'FormOverViewComponent'}}));

  }

  private getFilingOptionsQueryKey() {
    //return this.endpointName === 'SpreadsheetApi' ? 'ScenarioGetFilingOptionsConfig' : 'GetFilingOptionsConfig';
    switch (this.endpointName){
      case Api.Spreadsheet:
        return 'ScenarioGetFilingOptionsConfig';
      case Api.FilingManagerApi:
        let q= QueryProvider.getQuery('ScenarioGetFilingOptionsConfig');
        q.api = Api.FilingManagerApi;
        let k = 'FilingManagerFilingOptionsConfig'
        QueryProvider.addConfig(k,q);
        return k;
      default :
        return 'GetFilingOptionsConfig';
    }
  }
  private getformRowQueryKey() {
    switch (this.endpointName){
      case Api.Spreadsheet:
        return 'ScenarioFormRowById';
      case Api.FilingManagerApi:
        let q= QueryProvider.getQuery('ScenarioFormRowById');
        q.api = Api.FilingManagerApi;
        let k = 'FilingManagerFormRowById'
        QueryProvider.addConfig(k,q);
        return k;
      default :
        return 'FormRowById';
    }
  }
  onFieldSectionChanged($event){
    if($event.metaData && $event.metaData['DirectoryPath']){
      const caseId = this.item.cells['CaseId'].value;
      $event.metaData['DirectoryPath'] = $event.metaData['DirectoryPath'].replace('[CASE_ID]' ,caseId );
    }
  }

  onFieldSectionIndexChanged($event){
    this.selectedSectionHearderKey = $event;
  }

  updateLanguageToogle(command: PlatformCommand){
    this.showOriginal = command.isChecked;
    this.showOriginalChanged();
  }

  showExportFilingDialog( transmitToAuthority = false, command?) {
    this.executionId = Guid.create().toString();
    this.transmitToAuthority = transmitToAuthority;
    // We will remove this code once demo done.
    this.targetApi = command?.fieldValues['TargetApi'];
    if (!this.targetApi) {
      this.commandService.executeCommand(new SetExportFormSelectedItemCommand(this.formId, this.executionId));
    }
    const input = {
      'FORM_TEMPLATE_ID': this.item ? this.item.cells ? this.item.cells['FormTemplateId'] ? this.item.cells['FormTemplateId'].value : '' : '' : ''
    };
    const dialogModel = DialogModel.create('Select Form(s)', 'EntitySelectorDialogComponent', {
      filterId: this.executionId,
      filterTemplateId: 'dac6-export-forms-filter',
      apiKey: 'Dac6Api',
      input: input
    });
    dialogModel.minWidth = '1024px';
    dialogModel.maxWidth = '1024px';
    dialogModel.okCaption = 'Next';

    // We will remove this code once demo done.
    let formSourceType = this.item ? this.item.cells ? this.item.cells['FormSourceType'] ? this.item.cells['FormSourceType'].value : '' : '' : '';
    let scenarioType = this.item ? this.item.cells ? this.item.cells['ScenarioType'] ? this.item.cells['ScenarioType'].value : '' : '' : '';
    if(scenarioType === 'GMT') // Remove the code
    {
      this.handleDownloadNextAction(formSourceType, scenarioType);
      return;
    }
    // remove until here.
    this.dialogService.showOkCancelDialog(dialogModel)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe(actionState => {
        if (actionState && actionState.action === 'OK') {
          this.rightElementsCount = actionState.data.input.rightElementsCount;
          this.handleDownloadNextAction(formSourceType, scenarioType);
        }

      });
  }



  async handleDownloadNextAction(formSourceType: any, scenarioType: any) {
    if (this.transmitToAuthority) {
      const defaultExportOption = this.getExportDownloadOption();
      if(defaultExportOption.MetaData['HasReferenceTitleUi']){
        const dialogModel = DialogModel.create('Export Report', 'MxHallmarkReportExportInputDialogComponent', {}, '600px', '600px');
        this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(state=>{
          this.fuseSplashScreenService.show();
          const command = this.GetFillingManagerFormExportCommandByTargetApi(defaultExportOption);
          command.dictionary['FormSourceType'] = formSourceType;
          command.dictionary['ScenarioType'] = scenarioType;
          this.commandService.executeCommand(command).pipe(take(1)).subscribe(commandState => {
            if (commandState) {
              this.fuseSplashScreenService.hide();
              if (commandState.Payload.HasError) {
                this.showErrorReportDialog(commandState);
              } else {
                this.openTransmitFillingDialoge(commandState);
              }
            }
          });
        })
      }else{
        this.fuseSplashScreenService.show();
        let command = this.GetFillingManagerFormExportCommandByTargetApi(defaultExportOption);
        command.dictionary['FormSourceType'] = formSourceType;
        command.dictionary['ScenarioType'] = scenarioType;
        this.commandService.executeCommand(command).pipe(take(1)).subscribe(commandState => {
          if (commandState) {
            this.fuseSplashScreenService.hide();
            if (commandState.Payload.HasError) {
              this.showErrorReportDialog(commandState);
            } else {
              this.openTransmitFillingDialoge(commandState);
            }
          }
        });
      }
    }
    else {
      this.showDownloadDialog(this.rightElementsCount);
    }
  }

  private GetFillingManagerFormExportCommandByTargetApi(defaultExportOption) {
    if (this.targetApi && this.targetApi === Api.Spreadsheet) {
      return new SpreadsheetFillingManagerFormExportCommand(this.item.cells['CountryCode'].value, this.formId, this.executionId, defaultExportOption.DownloadType, true, defaultExportOption.MetaData['Process'], !this.showOriginal);
    } else {
      return new FillingManagerFormExportCommand(this.item.cells['CountryCode'].value, this.formId, this.executionId, defaultExportOption.DownloadType, true, defaultExportOption.MetaData['Process'], !this.showOriginal);
    }
  }

  openTransmitFillingDialoge(exportCommandResopnse) {
    if (exportCommandResopnse.Payload &&
      exportCommandResopnse.Payload.MetaData &&
      exportCommandResopnse.Payload.MetaData.transmitKey &&
      exportCommandResopnse.Payload.MetaData.transmitKey.length > 0) {
      const transmitKey = exportCommandResopnse.Payload.MetaData.transmitKey;
      this.fuseSplashScreenService.show();
      this.dac6ApiService.getAgreementByCountryCode(this.item.cells['CountryCode'].value,this.magicLinkModel?.tabBar?.tabs[0]?.tabData["EndpointName"]).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
        this.fuseSplashScreenService.hide();
        if (response) {
          const dialogModel: DialogModel = DialogModel.create(
            'Transmit Form(s)',
            'ConfirmTransmissionDialogComponent',
            { data: response }
          );
          dialogModel.okCaption = 'Transmit';
          this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe((item: any) => {
            if (item.action === 'OK') {
              let fieldValues = {};
              if(item &&
                item.data &&
                item.data.input &&
                item.data.input.TransmissionData &&
                item.data.input.TransmissionData.cells) {
                fieldValues = this.getDictionary(item.data.input.TransmissionData.cells);
              }
              let command;
              if(this.magicLinkModel?.tabBar?.tabs[0]?.tabData["EndpointName"] == Api.FilingManagerApi){
                command = new TransmitFileCommand(transmitKey, this.item.cells['CountryCode'].value, fieldValues,Api.FilingManagerApi);
              }
              else command = new TransmitFileCommand(transmitKey, this.item.cells['CountryCode'].value, fieldValues);
              this.fuseSplashScreenService.show();
              this.commandService.executeCommand(command).pipe(take(1)).subscribe(response => {
                this.fuseSplashScreenService.hide();
                this.router.navigate(['dac6-reporter/transmissions']);
              });
            }
          });
        }
      });
    }
    else {
      const title = this.rightElementsCount == 1 ? 'Transmit Form' : 'Transmit Form(s)';
      const dialogModel: DialogModel = DialogModel.create(
        title,
        'TransmitFormDialogComponent',
        {
          onClick: new EventEmitter<any>(),
          countryCode: this.item.cells['CountryCode'].value,
          scenarioType: this.item.cells['ScenarioType']?.value,
          targetApi: this.targetApi
        }
      );
      dialogModel.okCaption = 'Next';
      this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(item => {
        console.log('transmit:', item);
        if (item && item.action === 'OK') {
          this.downloadOrAttachToTask(this.rightElementsCount, exportCommandResopnse);
        }
      });
      dialogModel.input['onClick'].pipe(takeUntil(this.unSubscribe$)).subscribe(item => {
        console.log(item);
        if (item && item.type === 'Command') {
          this.showDownloadDialog(this.rightElementsCount, exportCommandResopnse);
        }
      });
    }
  }

  downloadOrAttachToTask(selectedItemCount, exportCommandResopnse) {
    const dialogModel: DialogModel = DialogModel.create(
      'Download or Attach to Task',
      'FilingDownloadOrAttachmentToTaskComponent',
      {
        clickAction: new EventEmitter<any>(),
        selectedItemCount: selectedItemCount,
        countryCode: this.item.cells['CountryCode'].value,
        scenarioType: this.item.cells['ScenarioType']?.value,
        options: this.filingExportOptions,
        transmission: this.transmitToAuthority
      }
    );
    dialogModel.minWidth = '520px';
    dialogModel.maxWidth = '520px';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(item => {
      console.log(item);
    });
    dialogModel.input['clickAction'].pipe(takeUntil(this.unSubscribe$)).subscribe(option => {
      console.log(option);
      if (option.includes('AttachtoTask')) {
        const fileType = option.split('-')[1];
        this.attachToTask(fileType, dialogModel.input['ExportOption'], exportCommandResopnse);
      } else {
        this.downloadForm(option, dialogModel.input['ExportOption'], exportCommandResopnse);
      }
    });
  }

  downloadForm(option: string, exportOption, exportCommandResponse) {
    if (!exportCommandResponse) {
      if(exportOption.MetaData['HasReferenceTitleUi']){
        const dialogModel = DialogModel.create('Export Report', 'MxHallmarkReportExportInputDialogComponent', {}, '600px', '600px');
        this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(state=>{
          const command = this.GetFillingManagerFormExportCommandByTargetApi(exportOption);
          this.fuseSplashScreenService.show();
          this.commandService.executeCommand(command).pipe(take(1)).subscribe(commandState => {
            if (commandState) {
              this.fuseSplashScreenService.hide();

              this.fileManagerFormExportActivityCommand = this.generateFileMangerExportActivityCommand(commandState,
                this.executionId, exportOption.MetaData['Process']);

              this.store.dispatch(new ExcelExportSourceFileDownloadAction(commandState.Payload));
              this.commandService.executePlatformCommand(this.fileManagerFormExportActivityCommand);
            }
          });
        })
      }
      else{
        let command = this.GetFillingManagerFormExportCommandByTargetApi(exportOption);
        command.dictionary['FormSourceType'] = this.item ? this.item.cells ? this.item.cells['FormSourceType'] ? this.item.cells['FormSourceType'].value : '' : '' : '';
        command.dictionary['ScenarioType'] = this.item ? this.item.cells ? this.item.cells['ScenarioType'] ? this.item.cells['ScenarioType'].value : '' : '' : '';
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).pipe(take(1)).subscribe(commandState => {
          if (commandState) {
            this.fuseSplashScreenService.hide();

            this.fileManagerFormExportActivityCommand = this.generateFileMangerExportActivityCommand(commandState,
              this.executionId, exportOption.MetaData['Process']);


            this.store.dispatch(new ExcelExportSourceFileDownloadAction(commandState.Payload));
            if (!this.targetApi) {
              this.commandService.executePlatformCommand(this.fileManagerFormExportActivityCommand);
            }
          }
        });
      }
    } else {
      if (exportCommandResponse.Payload.MetaData['IsDemo'] === true) {
        this.snackBarService.showError(exportCommandResponse.Payload.MetaData['DemoMessage']);
      } else {
        this.store.dispatch(new ExcelExportSourceFileDownloadAction(exportCommandResponse.Payload));
        this.fileManagerFormExportActivityCommand = this.generateFileMangerExportActivityCommand(exportCommandResponse,
          this.executionId, exportOption.MetaData['Process']);
        if (!this.targetApi) {
          this.commandService.executePlatformCommand(this.fileManagerFormExportActivityCommand);
        }
      }
    }
  }

  private attachToTask(fileType: string, exportOption, exportCommandResopnse = null) {
    /*    if(!exportCommandResopnse){
     const command = new FillingManagerFormExportCommand(this.formId, this.executionId, fileType, false);
     this.fuseSplashScreenService.show();
     this.commandService.executeCommand(command).subscribe(commandState =>{
     if(commandState){
     this.fuseSplashScreenService.hide();
     console.log('whats inside', commandState.Payload);
     this.attach(commandState.Payload.FileId, fileType);
     }
     });
     } else{
     console.log('whats inside not', exportCommandResopnse.Payload);
     this.attach(exportCommandResopnse.Payload.FileId, fileType);
     }*/

    this.attach(this.formId, this.executionId, fileType, exportOption);
  }

  private attach(formId: any, executionId: any, fileType: any, exportOption: any) {
    if ( exportOption.DownloadType === DownloadType.fvie ) {
      exportOption = this.filingExportOptions.ExportOptions.find(option => option.DownloadType === DownloadType.XML );
      fileType = DownloadType.XML;
    }
    const countryCode = this.item.cells['CountryCode'].value;
    const taskDetails = this.item.cells['DAC6FilingStatus']?.value;
    const caseId = this.item.cells['CaseId']?.value;
    const fileName = `${caseId}${countryCode}.${fileType}`;
    const scenarioType = this.item.cells['ScenarioType']?.value; //will remove scenarioType once GMT-Forms will move to GMT
    const command = new FormAttachmentToFilingTaskCommand(countryCode, formId, executionId, fileType, 'Dac6-Filling', exportOption.MetaData['Process']);
    command.scope = ContentScope.Company;
    command.parameters = {
      'ScenarioType': scenarioType
    };//will remove scenarioType once GMT-Forms will move to GMT
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(command).pipe(take(1)).subscribe(data => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showInformation('Attachment added successfully.');
      if (data && data.Payload) {
        this.taskManagerService.openTaskByTaskId(data.Payload.Id, GraphqlContentScope.getScope(data.Payload.Scope));
      }
    }, err => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showError(err.Payload);
    });
  }

  getDictionary(dict: any) {
    const ret = {};
    for (const key in dict) {
      ret[key] = dict[key].value;
    }
    return ret;
  }

  showErrorReportDialog(exportCommandResopnse) {
    const dialogRef = this.dialog.open(FilingErrorReportComponent, {
      minWidth: '750px',
      maxWidth: '850px',
      data: {
        transmitToAuthority: this.transmitToAuthority,
        exectionId: this.executionId,
        formId: this.formId,
        hasError: exportCommandResopnse.Payload.HasError,
        rightElementsCount: this.rightElementsCount,
        countryCode: this.item.cells['CountryCode'].value,
        targetApi: this.targetApi
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.unSubscribe$)).subscribe((result: string) => {
      if (result) {
        switch (result) {
          case 'download-form':
            this.showDownloadDialog(this.rightElementsCount, exportCommandResopnse);
            break;
          case 'transmit-to-authority':
            this.openTransmitFillingDialoge(exportCommandResopnse);
            break;
        }
      }
    });
  }

  showDownloadDialog(selectedItemCount, exportCommandResopnse = null) {
    const dialogModel: DialogModel = DialogModel.create(
      'Download or Save',
      'FilingExportOptionsDialogComponent',
      {
        clickAction: new EventEmitter<any>(),
        selectedItemCount: selectedItemCount,
        countryCode: this.item.cells['CountryCode'].value,
        scenarioType: this.item.cells['ScenarioType']?.value,
        options: this.filingExportOptions,
        transmission: this.transmitToAuthority
      }
    );
    dialogModel.minWidth = '520px';
    dialogModel.maxWidth = '520px';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(item => {
      console.log(item);
    });
    dialogModel.input['clickAction'].pipe(takeUntil(this.unSubscribe$)).subscribe(option => {
      console.log(option);
      if (option.includes('SaveToDrive')) {
        const fileType = option.split('-')[1];
        const metadata = { };
        if(this.item.cells['ScenarioType']?.value) {
          metadata['ScenarioType'] = this.item.cells['ScenarioType'].value;
        }
        if(this.item.cells['DriveId']?.value) {
          metadata['DriveId'] = this.item.cells['DriveId'].value;
        }
        if(this.item.cells['FolderId']?.value) {
          metadata['FolderId'] = this.item.cells['FolderId'].value;
        }

        if (exportCommandResopnse && exportCommandResopnse.Payload.MetaData['IsDemo'] === true) {
          metadata['IsDemo'] = exportCommandResopnse.Payload.MetaData['IsDemo'];
          metadata['DemoMessage'] = exportCommandResopnse.Payload.MetaData['DemoMessage'];
        }

        this.saveToDrive(this.executionId, fileType, dialogModel.input['ExportOption'], metadata);
      } else {
        this.downloadForm(option, dialogModel.input['ExportOption'], exportCommandResopnse);
      }
    });
  }

  saveToDrive(executionId: string, fileType: string, exportOption: any, metadata: {}) {
    if (metadata['IsDemo'] === true) {
      this.snackBarService.showError(metadata["DemoMessage"]);
      return;
    }
    const dialogRef = this.dialog.open(FileDialogComponent, {
      minWidth: '600px',
      maxWidth: '600px',
      data: {
        itemsUrlIndex: 1,
        type: metadata['ScenarioType'] ? 'DirectoryEntries' : 'SharedDrives',
        folderId: metadata['FolderId'] ? metadata['FolderId'] : '',
        driveId: metadata['DriveId'] ? metadata['DriveId'] : '',
        isFileSelector: false,
        viewType: 'TeamDrive',
        title: 'Select Folder'
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.unSubscribe$)).subscribe((result: any) => {
      const selectedFolderInfo = result;
      if (selectedFolderInfo && selectedFolderInfo !== '') {
        const parentId = selectedFolderInfo.id;
        const driveId = selectedFolderInfo.cells.ItemId.value;
        const dictionary = {};
        if(metadata['ScenarioType']) {
          dictionary['ScenarioType'] = metadata['ScenarioType'];
        }

        let command = this.GetFillingManagerFormExportCommandByTargetApi(exportOption);
        command.dictionary['ScenarioType'] = metadata['ScenarioType'] ? metadata['ScenarioType'] : '';
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).pipe(take(1)).subscribe((commandState) => {
          this.fuseSplashScreenService.hide();

          this.fileManagerFormExportActivityCommand = this.generateFileMangerExportActivityCommand(commandState,
            this.executionId, exportOption.MetaData['Process']);

          if (!this.targetApi) {
            this.commandService.executePlatformCommand(this.fileManagerFormExportActivityCommand);
          }

          this.snackBarService.showInformation('Form(s) are saved to drive successfully.');
        });
      }
    });
  }

  generateFileMangerExportActivityCommand(response: NotificationMessageModel, executionId: string, process: string): PlatformCommand{
    const command = new PlatformCommand("ExportFormActivityCommand", "DAC6Api");

    command.fieldValues["FileName"] = response.Payload.FileName;
    command.fieldValues["FileId"] = response.Payload.FileId;
    command.fieldValues["Process"] = process;
    command.fieldValues["ExecutionId"] = executionId;

    return command;
  }

  private getExportDownloadOption() {
    let downloadType = this.filingExportOptions.DefaultDownloadType;
    let selectedExportOption;
    if(this.rightElementsCount > 1){
      let hasMergedItems = false;
      this.filingExportOptions.ExportOptions.forEach(item=>{
        if(item.IsMerge){
          hasMergedItems = true;
        }
      });
      if( hasMergedItems ) downloadType = DownloadType.XML;
      else if( downloadType !== DownloadType.fvie ) downloadType = DownloadType.ZIP;
    }
    else {
      if ( downloadType === DownloadType.ZIP ) downloadType = DownloadType.XML;
    }
    selectedExportOption = this.filingExportOptions.ExportOptions.find(option=>option.DownloadType === downloadType);
    if(!selectedExportOption){
      downloadType = this.filingExportOptions.DefaultDownloadType;
      selectedExportOption = this.filingExportOptions.ExportOptions.find(option=>option.DownloadType === downloadType);
    }
    return selectedExportOption;
  }

  showOriginalChanged() {
    this.invalidateLanguage();
  }

  private invalidateLanguage() {
    this.invalidateSubject.invalidate(this.showOriginal ? 'Original' : 'Translated');
  }

  exportAndTransmit(command: PlatformCommand) {
    this.showExportFilingDialog(true, command);
  }

  save(command: PlatformCommand) {
    this.editedFields = command.fieldValues['editedFields'];
    const item = command.fieldValues['item'];
    let formRowQueryKey = this.getformRowQueryKey();
    if (this.editedFields.length) {
      item['itemId'] = this.item.itemId;
      item['sourceItemId'] = this.item.sourceItemId;
      const command = new SaveFormFieldCommand(this.endpointName, item);
      this.commandService.executeCommand(command).pipe(take(1)).subscribe(commandState => {
        this.invalidateSubject.invalidate('SaveChanges|' + Guid.create().toString());
        QueryProvider.invokeQuery(this.store, formRowQueryKey, {'[ID]': this.formId});
      });
    } else {
      QueryProvider.invokeQuery(this.store, formRowQueryKey, {'[ID]': this.formId});
    }
  }

  private isReadyToLoadContainer(){
    if(this.sourceType && this.formField && this.item && this.fieldConfig && this.formFieldsValidationState && this.formFieldsErrorInformation){
      this.dynamicFormService.emitIsReadyToLoadContainer(true);
    }
    else{
      this.dynamicFormService.emitIsReadyToLoadContainer(false);
    }
  }

  startDataSurvey() {
    const title = this.item.cells['FormTitle'].value;
    const caseId = this.item.cells['CaseId'].value;
    this.dialogService.showAddSurveyDialog(`${caseId}-${title}`).pipe(takeUntil(this.unSubscribe$))
      .subscribe((res: any) => {
        if (res && res.action == 'OK') {
          console.log(res);
          const collaborativeTemplateId = 'collaborative-dac6-form';
          const individualTemplateId = 'individual-dac6-form';
          const surveyTemplateId = res.data.input.isIndividualResponse ? individualTemplateId : collaborativeTemplateId;
          // const command = new StartDataSurveyFromTemplateCommand(this.item.id,
          //   surveyTemplateId,
          //   res.data.input.title,
          //   res.data.input.description,
          //   caseId
          // );
          const command = new PlatformCommand('CreateTaxFormSurveyCommand', 'DataSurveyApi');
          command.fieldValues['TemplateId'] = surveyTemplateId;
          command.fieldValues['ItemId'] = this.item.id;
          command.fieldValues['SurveyTitle'] = res.data.input.title;
          command.fieldValues['Description'] = res.data.input.description;

          this.fuseSplashScreenService.show();
          this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(state => {
            console.log('StartDataSurveyFromTemplateCommand returned ', state);
            this.fuseSplashScreenService.hide();
            if (state && state.fieldValues && state.fieldValues['RedirectUrl']) {
              this.router.navigateByUrl(state.fieldValues['RedirectUrl']);
            }
          }, error => {
            console.error(error);
            this.fuseSplashScreenService.hide();
          });
        }
      });
  }

  private getFormFieldConfiguration() {
    const formQueryKey = 'DynamicFormKey';
    const formQuery = {...QueryProvider.getQuery(formQueryKey)};
    formQuery.key = formQueryKey + this.sourceType;
    formQuery.api = this.endpointName;
    let formFieldCache = this.particleCacheService.getItem(formQuery.key);
    if (!formFieldCache || formFieldCache.version !== this.particleCacheService.getClientConfigVersion()) {
      QueryProvider.addConfig(formQuery.key, formQuery);
      this.formState$ = this.queryState.pipe(select(getQueryResponse, formQuery.key)).pipe(take(2));
      this.formState$.pipe(takeUntil(this.unSubscribe$)).subscribe(formState => {
        if (formState) {
          formFieldCache = new ParticleCacheModel();
          formFieldCache.version = this.particleCacheService.getClientConfigVersion();
          formFieldCache.value = formState;
          this.particleCacheService.saveItem(formQuery.key, formFieldCache);
          this.updateFormField(formState);
        }
      });
      QueryProvider.invokeQuery(this.queryState, formQuery.key, {'[SOURCE_TYPE]': this.sourceType});
    } else {
      this.updateFormField(formFieldCache.value);
    }
  }

  private updateFormField(formState) {
    this.formField = formState.formField;
    if (this.formField.viewType === 'Tab') {
      this.containerClass = 'content m-lr-30';
    } else {
      this.containerClass = 'content m-30 m-lr-30';
    }
    this.fieldConfig = formState.fieldConfig;
    this.showLanguageOption = this.formField.hasLanguageOption;
    this.showOriginal = this.formField.defaultShowOriginalLanguage;
    this.dynamicFormService.emitFormField(this.formField);
    this.dynamicFormService.emitFieldConfig(this.fieldConfig);
    this.dynamicFormService.emitContainerClass(this.containerClass);
    this.isReadyToLoadContainer();
    this.invalidateSubject.invalidate('PlatformToolDynamicFormHandler|' + Guid.create().toString());
  }

  private setFieldValidation(response: any) {
    this.formFieldsValidationState = {};
    response.forEach(item => {
      if (item.validateModels) {
        item.validateModels.forEach(model => {
          this.updateFieldValidationStatus(model);
        });
      }
    });
  }

  private updateFieldValidationStatus(model: any) {
    switch (model.fieldStatus) {
      case 0:
        this.formFieldsValidationState[model.formId + '__' + model.fieldKey] = {
          isValid: 'Yes',
          errorMessage: model.message
        };
        break;
      case 1:
        this.formFieldsValidationState[model.formId + '__' + model.fieldKey] = {
          isValid: 'Yes',
          errorMessage: model.message
        };
        break;
      case 2:
        this.formFieldsValidationState[model.formId + '__' + model.fieldKey] = {
          isValid: 'No',
          errorMessage: model.message
        };
        break;
      case 3:
        this.formFieldsValidationState[model.formId + '__' + model.fieldKey] = {
          isValid: 'No',
          errorMessage: model.message
        };
        break;
    }
  }

  private subscribeToSocketCluster(itemId) {
    let formRowQueryKey = this.endpointName ==='SpreadsheetApi' ? 'ScenarioFormRowById':'FormRowById';
    if (!this.hasSubscribedToSocketCluster) {
      this.socketClusterService.subscribeToChannel(itemId, function(notification) {
        console.log('Notification received for item ' + itemId, notification);
        QueryProvider.invokeQuery(this.store, formRowQueryKey, {'[ID]': this.formId});
      }.bind(this));
      this.hasSubscribedToSocketCluster = true;
    }

  }

  destroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
    this.dynamicFormService.destroy();
    this.formState$ = null;
    if (this.hasSubscribedToSocketCluster && this.formId) {
      this.socketClusterService.unsubscribeChannel(this.formId);
    }
    this.queryModels.forEach(q => {
      this.queryState.dispatch(new DeleteQueryAction(q, null, null));
    });
  }


  private getAllHeaderSection(formId: any, endpointName: string=Api.DAC6) {

    this.dac6ApiService.getAllHeaderSectionsFormFieldsErrorInfo(formId,Configuration.getConfig(endpointName)).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
      if (response) {
        this.formFieldsErrorInformation = {};
        response.forEach(item => this.formFieldsErrorInformation[item.headerSectionKey + '__' + item.formId] = item);
        this.setFieldValidation(response);
        this.dynamicFormService.emitFormFieldsErrorInformation(this.formFieldsErrorInformation);
        this.dynamicFormService.emitFormFieldsValidationState(this.formFieldsValidationState);
        this.isReadyToLoadContainer();
        this.invalidateSubject.invalidate('PlatformToolDynamicFormHandler|' + Guid.create().toString());
      }
    });
    // if(endpointName == 'SpreadsheetApi'){
    //   this.dac6ApiService.getAllHeaderSectionsFormFieldsErrorInformationFromSpreadsheet(formId).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
    //     if (response) {
    //       this.formFieldsErrorInformation = {};
    //       response.forEach(item => this.formFieldsErrorInformation[item.headerSectionKey + '__' + item.formId] = item);
    //       this.setFieldValidation(response);
    //       this.dynamicFormService.emitFormFieldsErrorInformation(this.formFieldsErrorInformation);
    //       this.dynamicFormService.emitFormFieldsValidationState(this.formFieldsValidationState);
    //       this.isReadyToLoadContainer();
    //       this.invalidateSubject.invalidate('PlatformToolDynamicFormHandler|' + Guid.create().toString());
    //     }
    //   });
    // }else{
    //   this.dac6ApiService.getAllHeaderSectionsFormFieldsErrorInformation(formId).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
    //     if (response) {
    //       this.formFieldsErrorInformation = {};
    //       response.forEach(item => this.formFieldsErrorInformation[item.headerSectionKey + '__' + item.formId] = item);
    //       this.setFieldValidation(response);
    //       this.dynamicFormService.emitFormFieldsErrorInformation(this.formFieldsErrorInformation);
    //       this.dynamicFormService.emitFormFieldsValidationState(this.formFieldsValidationState);
    //       this.isReadyToLoadContainer();
    //       this.invalidateSubject.invalidate('PlatformToolDynamicFormHandler|' + Guid.create().toString());
    //     }
    //   });
    // }
  }


}
